import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import index from '../../../utils/index'

export default {
  name: 'trip-generate-connection-print',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      showTable: true,
      ConnectionDetails: {},
      ManifestDetails: [],
      ClientName: '',
      ManifestNumber: '',
      ScheduleDate: '',
      ScheduleId: '',
      printDate: '',
      printBy: '',
      isDisplay: false,
      isLoadingSearch:false,
      viewBagOctroilListModel:false,
      BagOctroilListArray:[],
      isDisplayButton:true,
      PrintDate:'',
      PrintBy:'',
      isDisplayForMongo:false,
      BagOctroilListArrayForMongo:[],
      GSTRegNo:'',
      manifestationDate:'',
      city:'',
      printConfig : false,
      isHidePrintManifestReport: false
    }
  },
  created: function() {},
  model: {},
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    TotalMRP: function(data) {
      var resultMRP;
      for (var i = 0; i < data.length; i++) {
        resultMRP = data[i].ordervalue
      }
      if (resultMRP == null) {
        return 0
      }
      var total = data.reduce(function(totalMRP, item) {
        return totalMRP + parseFloat(item.ordervalue);
      }, 0);
      var with2Decimals = total.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      return with2Decimals
    },
    ShipmentCount: function(data) {
      if (data.length == 0) {
        return 0
      } else {
        return data.length
      }
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email
    this.pageName = localStorage.getItem('pageName');
  },
  methods: {
    showManifest(type) {
      this.getConnectionDetails();
      if(type=="Mongo"){
        this.getManifestDetails('Mongo');
      }else{
        this.getManifestDetails();
      }
    },
    getBagOctroilList(data) {
      this.isDisplayForMongo=false;
      if (this.$route.params.CSMID && this.$route.params.hubid) {
        var csmid = this.$route.params.CSMID;
        var hubId = this.$route.params.hubid;

      this.BagOctroilListArray = [];
      this.PrintBy = this.createdBy
      this.PrintDate = new Date();
      this.input = ({});
      this.isHidePrintManifestReport = false;
      this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'generateBagwiseOctroilList?list=list&connectionschedulemasterid=' + this.$route.params.CSMID + '&hubid=' + this.$route.params.hubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.isDisplay = true;

            // this.viewBagOctroilListModel = true;
            this.BagOctroilListArray = result.data.ResponseData;

            // Hide Print Manifest Report View based on Flag
            this.isHidePrintManifestReport = result.data.isHidePrintManifestReport;
          } else {
            this.isDisplay = false;
            this.isDisplayForMongo=false;

            this.viewBagOctroilListModel = false;
            this.BagOctroilListArray = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
      } else {
        this.$alertify.error("CSMID Is not Found,Try again");
      }
    },
    getBagOctroilListForMogo(data) {
      this.isDisplay = false;

      if (this.$route.params.CSMID && this.$route.params.hubid) {
        var csmid = this.$route.params.CSMID;
        var hubId = this.$route.params.hubid;

      this.BagOctroilListArray=[]
      this.PrintBy = this.createdBy
      this.PrintDate = new Date();
      this.printConfig = false;
      this.input = ({});
      this.isHidePrintManifestReport = false;
      this.isLoadingSearch = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'generateBagwiseOctroilListNewAPI?connectionschedulemasterid=' + this.$route.params.CSMID + '&hubid=' + this.$route.params.hubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.printConfig =  index.configRolesCheck(result.data.config.pr_web_roles);
            // if(!this.printConfig) {
            //   this.$alertify.error("No Printing Access");
            //   return;
            // }
            this.isDisplayForMongo = true;

            this.BagOctroilListArrayForMongo = result.data.ResponseData;
            this.GSTRegNo=this.BagOctroilListArrayForMongo[0].GSTRegNo;
            this.manifestationDate=this.BagOctroilListArrayForMongo[0].manifestationDate
            this.city=this.BagOctroilListArrayForMongo[0].city

            // Hide Print Manifest Report View based on Flag
            this.isHidePrintManifestReport = result.data.isHidePrintManifestReport;
          } else {
            this.viewBagOctroilListModel = false;
            this.isDisplay = false;
            this.isDisplayForMongo=false;
            this.BagOctroilListArray = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
      } else {
        this.$alertify.error("CSMID Is Not Found, Try again");
      }
    },

    printManifest() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:2px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .td-width{
             width:10px!important;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
            .print-only {
              display: block;
            }
            .no-print {
              display: none !important;
            }
          }
          `
      d.print(document.getElementById('printManifestContent'), cssText);
    },
    printOctraForMongo() {
      const d = new Printd();
      var buffer = '';
      this.isLoadingSearch = true;

        this.input = {
        "currentHubId" : Number( this.$route.params.hubid),
        "tripId" : Number(String(this.$route.params.CSMID).trim()),
        "createdBy" : this.printBy,
        "reportName" : 'Print Octroil',
        "pageName" : this.pageName,
      }

      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'printGatePass',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
        this.isLoadingSearch = false;
        if(result.data.ResultCode == 100) {
          this.alertify.success(result.data.ReturnMessage);
        } else {
          this.alertify.error(result.data.ReturnMessage);
				}
      })
      .catch((error) => {
         this.isLoadingSearch = false;
        this.alertify.error(error)
        console.log(error)});
	  
      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:2px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .td-width{
             width:10px!important;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
            .print-only {
              display: block;
            }
            .no-print {
              display: none !important;
            }
          }
          `
      d.print(document.getElementById('printOctroilListForMongo'), cssText);
    },
    toFixedVal(val) {
      // console.log(val);
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },

  },
}



// WEBPACK FOOTER //
// ./src/views/components/generateBagOctroilListPrint/generateBagOctroilListPrint.js